var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveTags(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16665 0.833252L12.5 12.1666L11.6666 12.9999L10.3333 11.6666H2.33331C1.59998 11.6666 0.99998 11.0666 0.99998 10.3333V3.66659C0.99998 3.29992 1.15331 2.96659 1.39331 2.72659L0.333313 1.66659L1.16665 0.833252ZM13.6666 6.99992L10.7533 2.89325C10.5133 2.55325 10.1133 2.33325 9.66665 2.33325H4.33331L11.6666 9.66659L13.6666 6.99992Z",
    fill: "#828282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveTags);
export default __webpack_public_path__ + "static/media/remove_tags.6beb98a4b9e15e8e9bcb5185342dd590.svg";
export { ForwardRef as ReactComponent };